import ReactGA from 'react-ga'
import TagManager from 'react-gtm-module'
import getConfig from "next/config";

export const initGA = () => {
  ReactGA.initialize(getConfig().publicRuntimeConfig.gaId)
  TagManager.initialize({
    gtmId: getConfig().publicRuntimeConfig.gaId,
  })
}

export const logPageView = () => {
  ReactGA.set({ page: window.location.pathname })
  ReactGA.pageview(window.location.pathname)
}
